import { type FC } from 'react';
import { Grid, Stack } from '@mantine/core';
import { CascadeTemplateDangerZone } from './components/CascadeTemplateDangerZone';
import { CascadeTemplateEditorHeader } from './components/CascadeTemplateEditorHeader';
import { CascadeTemplateGroupsCard } from './components/CascadeTemplateGroupsCard';
import { useCascadeTemplateEditor } from './lib';

interface CascadeTemplateEditorProps {
    id?: string;
}

export const CascadeTemplateEditor: FC<CascadeTemplateEditorProps> = ({ id }) => {
    const editor = useCascadeTemplateEditor(id);

    return (
        <Stack gap='md'>
            <CascadeTemplateEditorHeader
                isNew={editor.isNew}
                templateId={id}
            />

            <Grid gap='md'>
                <Grid.Col span={{ base: 12, md: 8 }}>
                    <CascadeTemplateGroupsCard
                        name={editor.name}
                        onNameChange={editor.setName}
                        entries={editor.entries}
                        onEntriesChange={editor.setEntries}
                        groupOptions={editor.groupOptions}
                        isGroupOptionsLoading={editor.isGroupOptionsLoading}
                        onAddGroup={editor.handleAddGroup}
                        onClear={editor.handleClear}
                        isValid={editor.isValid}
                        isSubmitPending={editor.isSubmitPending}
                        onSubmit={editor.handleSubmit}
                    />
                </Grid.Col>

                {!editor.isNew && (
                    <Grid.Col span={{ base: 12, md: 4 }}>
                        <CascadeTemplateDangerZone
                            isPending={editor.isDeletePending}
                            onDelete={editor.handleDelete}
                        />
                    </Grid.Col>
                )}
            </Grid>
        </Stack>
    );
};
